import {
  Home,
  GroupOutlined,
  RecentActorsOutlined,
  CasesOutlined,
  ViewTimelineOutlined,
  BadgeOutlined,
  AssessmentOutlined,
  Schedule,
  Payments,
  RequestPage,
  WorkOffOutlined,
  FreeCancellation,
  BeachAccess,
  RequestPageOutlined,
  RequestQuoteOutlined,
  Dashboard,
  HouseOutlined,
  PersonAddAlt,
} from '@mui/icons-material';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import { Badge } from '@mui/material';
import ReactIntlWrapper from 'components/i18n/ReactIntlWrapper';
import { JSX } from 'react';

export function renderModuleAvatar(module) {
  // Dictionary to map notification's module property to icons
  const moduleIconMap: Record<string, JSX.Element> = {
    address: <HouseOutlined />,
    home: <Home />,
    client: <GroupOutlined />,
    provider: <RecentActorsOutlined />,
    project: <CasesOutlined />,
    timesheet: <ViewTimelineOutlined />,
    employee: <BadgeOutlined />,
    reports: <AssessmentOutlined />,
    reports_timesheet: <Schedule />,
    reports_billing: <Payments />,
    reports_billing_client: <RequestPage />,
    timeoff: <WorkOffOutlined />,
    timeoffrrhh: <FreeCancellation />,
    holidays: <BeachAccess />,
    invoice: <RequestPageOutlined />,
    myInvoices: <RequestQuoteOutlined />,
    corporateEntity: <Badge/>,
    role: <Badge/>,
    billing: <Payments/>,
    event: <BeachAccess/>,
    contactInfo: <ContactPhoneIcon/>,
    job: <CasesOutlined/>,
    task: <CasesOutlined/>,
    user: <PersonAddAlt/>,
    workflow: <Badge/>
  
  };

  const icon = moduleIconMap[module];

  return icon || <Dashboard />;
}

export function getNotificationLocale(resourceId: string, params: { [key: string]: string }[]): string {
  const values = Object.assign(
    {},
    ...params.map((param) => {
      const [key, value] = Object.entries(param)[0];

      // Si el value es una clave de traducción, usamos la traducción
      const translatedValue = ReactIntlWrapper.has(value) ? ReactIntlWrapper.get(value) : value;

      return { [key]: translatedValue };
    })
  );

  return ReactIntlWrapper.get(resourceId, values);
}

export const getRowHeight = (params) => {
  try {
    const parsed = JSON.parse(params.model.message);
    const localeText = getNotificationLocale(parsed.message?.ResourceID, parsed.message?.Params || []) ;
    
    const charsPerLine = 80; 
    const lines = Math.ceil(localeText.length / charsPerLine);
    const baseHeight = 50;
    const lineHeight = 20;
    
    return Math.max(70, baseHeight + (lines * lineHeight));
  } catch (error) {
    return 70;
  }
}